export const CAST = Object.freeze({
  mara: { name: 'Mara Quill', role: 'Keeper of names', home: 'brackenwake', quest: 'lantern-in-the-mist', x: -7, z: 5,
    lines: [
      ['neutral', 'You came back. I kept your name in the bell ledger, even when the Covenant ordered me to cross it out.'],
      ['hurt', 'Pell rode east with medicine for the fen children. His horse returned. His lantern did not. Tonight the bell rang in his voice.'],
      ['angry', 'They want to seal the road and call everyone beyond it lost. I will not turn a missing person into a tidy entry.'],
      ['happy', 'Find the lantern moving against the wind. Bring Pell home. Then ask me to walk beside you - not behind an order.'],
    ] },
  oren: { name: 'Oren Flint', role: 'Scout of the Ash Pack', home: 'greyfen', quest: 'scars-in-greyfen', x: -6, z: 7,
    lines: [['angry', 'Stop. The tracks split here, but only one trail has a scent. Someone is teaching the dead to imitate us.'],
      ['hurt', 'My sister followed a familiar voice into that fog. I have spent three winters refusing to hear it again.'],
      ['neutral', 'Leave the loud road. Watch the grass bend before you move. Earn the pack a safe passage, and I will guide yours.']] },
  sable: { name: 'Sable Rook', role: 'Physician without a court', home: 'red-chapel', quest: 'chapel-beneath-blood', x: -8, z: 6,
    lines: [['neutral', 'Hold still. That pulse is not a curse. It is two lives trying to share one heartbeat.'],
      ['angry', 'Voss calls his prisoners patients. I used to sign those records. I will not ask you to forgive the handwriting.'],
      ['hurt', 'Break the altar before another name becomes a blood debt. Then we can discuss what healing actually costs.']] },
  tamsin: { name: 'Tamsin Reed', role: 'Keeper of the river routes', home: 'hollow', quest: 'hollow-ledger', x: -5, z: 8,
    lines: [['happy', 'Welcome to Hollow. The soup is free. The gossip costs a useful lie. You look like you have several.'],
      ['hurt', 'The census boat took twelve people last week. Yesterday the village forgot eleven of their names.'],
      ['angry', 'Steal the ledger, not the coins. A name returned is a door the Crown cannot lock.']] },
});

export function isRecruited(campaign, id) {
  return Boolean(CAST[id] && campaign?.flags?.[`recruited-${id}`] === true);
}

export function canRecruit(campaign, id) {
  return Boolean(CAST[id] && campaign?.completedQuestIds?.includes(CAST[id].quest));
}

export function castForSpeaker(speaker = '') {
  const normalized = speaker.toLowerCase();
  return Object.keys(CAST).find((id) => normalized.includes(id) || normalized === CAST[id].name.toLowerCase()) || null;
}

export function portraitPath(id, expression = 'neutral') {
  if (!CAST[id]) return null;
  const mood = ['neutral', 'happy', 'angry', 'hurt'].includes(expression) ? expression : 'neutral';
  return `/assets/portraits/${id}-${mood}.png`;
}
